/**
 * src/domain/inventory/InventoryPolicy.ts
 *
 * Normalized Currency Step-Up Challenge Policy (RFC 9470).
 */

const STEP_UP_USD_THRESHOLD = 10_000;

export class InventoryPolicy {
  public static requiresHighValueStepUp(price: { amount: number | null; currency: string }): boolean {
    if (price.amount === null || typeof price.amount !== 'number') return false;

    const ratesToUSD: Record<string, number> = {
      USD: 1.0,
      EUR: 1.08,
      GBP: 1.28,
      JPY: 0.0067,
      AUD: 0.65,
      CAD: 0.74,
      CHF: 1.13,
      SGD: 0.76,
    };

    const normalizedUSD = price.amount * (ratesToUSD[price.currency.toUpperCase()] || 1.0);
    return normalizedUSD >= STEP_UP_USD_THRESHOLD;
  }
}
